import { render } from "./SelectedFilter.vue?vue&type=template&id=2cd164ee&ts=true"
import script from "./SelectedFilter.vue?vue&type=script&lang=ts"
export * from "./SelectedFilter.vue?vue&type=script&lang=ts"

import "./SelectedFilter.vue?vue&type=style&index=0&id=2cd164ee&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__